/**
 * 商品画像情報画面の画像詳細情報クラス
 *
 * @export ImageDetailListInfo
 * @class ImageDetailListInfo
 */
export class ImageDetailListInfo {
  constructor(
    // 表示順
    public showSeq: string = null,
    // 画像ファイルID
    public imageFileId: string = null,
    // 画像ファイル名
    public imageFileName: string = null,
    // ファイルパス
    public fileImagePath: string = null,
    // 確認フラグ
    public ImageCheckFlag: string = null,
    // 新規画像登録フラグ（trueの場合は新規画像登録ボタンから追加された場合）
    public imageInstructFlag: boolean = false,
    // 新規画像登録変更フラグ（trueの場合は新規画像登録ボタンから追加されて変更された場合）
    public imageInstructChangFlag: boolean = false,
    // 調理例掲載区分
    public cookingExPublish: string = null,
    // 画像名
    public imageName: string  = null,
    // 使用開始受注コード
    public startOrderCodeImageId: string = null,
    // 画像キャプション
    public textCaption: string = null,
  ) {}
}
  